import { c as _c } from "react/compiler-runtime";
/**
 * ContentSection Component
 *
 * A wrapper component for page sections with proper container
 * and spacing. Used to group related content like feature blocks.
 *
 * @example
 * <ContentSection>
 *   <SectionHeader subheading="Desktop Viewing" title="Key Features" />
 *   <FeatureBlock ... />
 *   <FeatureBlock ... />
 * </ContentSection>
 */

import { cn } from '@/lib/utils';
interface ContentSectionProps {
  /** Section content */
  children: React.ReactNode;
  /** Additional CSS classes */
  className?: string;
  /** Background color variant */
  variant?: 'default' | 'gray';
  /** Section ID for anchor links */
  id?: string;
  /** Exact vertical padding supplied by a page design. */
  pad?: string;
  /** Exact section background supplied by a page design. */
  background?: string;
  /** Exact top margin supplied by a page design. */
  marginTop?: string;
  /** Override the semantic wrapper when embedding a design import band. */
  as?: 'section' | 'div';
}
export function ContentSection(t0) {
  const $ = _c(16);
  const {
    children,
    className,
    variant: t1,
    id,
    pad,
    background,
    marginTop,
    as: t2
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  const Element = t2 === undefined ? "section" : t2;
  const t3 = !pad && "py-12 md:py-16 lg:py-20";
  const t4 = variant === "gray" && "bg-gray-50";
  let t5;
  if ($[0] !== className || $[1] !== t3 || $[2] !== t4) {
    t5 = cn(t3, t4, className);
    $[0] = className;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== background || $[5] !== marginTop || $[6] !== pad) {
    t6 = {
      background,
      marginTop,
      padding: pad
    };
    $[4] = background;
    $[5] = marginTop;
    $[6] = pad;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== children) {
    t7 = <div className="page-container">{children}</div>;
    $[8] = children;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== Element || $[11] !== id || $[12] !== t5 || $[13] !== t6 || $[14] !== t7) {
    t8 = <Element id={id} className={t5} style={t6}>{t7}</Element>;
    $[10] = Element;
    $[11] = id;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}